import { render, staticRenderFns } from "./ChatListItemAdvancedDummy.vue?vue&type=template&id=097ab1fd&"
import script from "./ChatListItemAdvancedDummy.vue?vue&type=script&lang=js&"
export * from "./ChatListItemAdvancedDummy.vue?vue&type=script&lang=js&"
import style0 from "./ChatListItemAdvancedDummy.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports